import { useIdle, useTimestamp } from '@vueuse/core'
import { computed } from 'vue'

export function useInactivityMonitor() {
  const { lastActive } = useIdle(5000)
  const now = useTimestamp({ interval: 1000 })
  const userStore = useUserStore()
  const idledFor = computed(() => {
    // Don't track inactivity if user is not authenticated or currently logging out
    if (!userStore.isAuthenticated || userStore.loggingOut) return 0
    return Math.floor((now.value - lastActive.value) / 1000)
  })
  return {
    idledFor
  }
}
